<template>
  <section>
    <!-- host -->
    <div v-if="userPrivilege === 'host'">
      <div
        class="desktop:mb-[10px] mobile:mb-2 cursor-pointer"
        @click="$router.replace('/mypage/group/admin-infomation')"
      >
        그룹관리
      </div>

      <div class="desktop:text-base mobile:text-sm ml-4">
        <div v-for="(item, index) in hostSubMenuList" :key="index" class="mb-2">
          <router-link :to="`/mypage/group/${item.path}`">
            {{ $t(String(item.name)) }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- none, guest -->
    <div v-else>
      <router-link to="/mypage/group">그룹관리</router-link>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import { routerMypage } from "@/router/children";
import { RouteRecordRaw } from "vue-router";
import { useComposition } from "@/lib/mypage/useMypage";

export default defineComponent({
  name: "MypageGroupSubmenu",
  setup: () => {
    const route = useRoute();
    const { userPrivilege } = useComposition();
    const hostSubMenuList = computed(() => {
      const groupRouter: RouteRecordRaw[] = routerMypage.children!.filter(
        (sub) => sub.path === "group"
      );
      const adminRouter = groupRouter[0].children!.filter(
        (sub) => sub.path.indexOf("admin") !== -1
      );
      return adminRouter;
    });

    const openSubMenu = computed(() => route.path.indexOf("group") !== -1);

    return {
      hostSubMenuList,
      openSubMenu,
      userPrivilege,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/style/screens/screen.scss";
.router-link-active {
  @include desktop {
    text-decoration: underline;
    text-underline-position: under;
  }
  @include mobile {
    font-weight: 700;
  }
}
</style>
